'use client';

import Image from 'next/image';
import { useState } from 'react';
import { cn } from '../../../lib/utils';

export type LandingDashboardPreviewProps = {
  src: string;
  alt: string;
  className?: string;
};

function DashboardPlaceholder() {
  return (
    <div
      className='flex aspect-4/3 w-full flex-col gap-4 bg-white p-6'
      aria-hidden
    >
      <div className='h-6 w-28 rounded bg-neutral-200' />
      <div className='grid flex-1 gap-3 sm:grid-cols-3'>
        <div className='rounded-xl bg-neutral-100 sm:col-span-1' />
        <div className='rounded-xl bg-neutral-100 sm:col-span-1' />
        <div className='rounded-xl bg-neutral-100 sm:col-span-1' />
      </div>
      <div className='grid flex-1 gap-3 sm:grid-cols-2'>
        <div className='rounded-xl bg-neutral-100' />
        <div className='rounded-xl bg-neutral-100' />
      </div>
    </div>
  );
}

export function LandingDashboardPreview({
  src,
  alt,
  className,
}: LandingDashboardPreviewProps) {
  const [failed, setFailed] = useState(false);

  return (
    <div
      className={cn(
        'overflow-hidden rounded-2xl bg-white shadow-[0_8px_32px_rgba(0,0,0,0.18)] lg:rounded-3xl',
        className,
      )}
    >
      {failed ? (
        <DashboardPlaceholder />
      ) : (
        <Image
          src={src}
          alt={alt}
          width={431}
          height={280}
          className='h-auto w-full object-contain'
          sizes='(max-width: 1024px) 100vw, min(560px, 50vw)'
          priority={false}
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
